export default __webpack_public_path__ + "static/media/CDU.a4a2254f.png";